export default __webpack_public_path__ + "static/media/Ballroll_00214.8f10fce9.png";